import React from 'react'
import './ZaloLink.css'

export default function ZaloLink() {
  return (
    <div class="zalo-container left">
    <a id="zalo-btn" href="https://zalo.me/0964345934" target="_blank" rel="noopener nofollow">
        <div class="animated_zalo infinite zoomIn_zalo cmoz-alo-circle"></div>
        <div class="animated_zalo infinite pulse_zalo cmoz-alo-circle-fill"></div>
        <span><img src="https://vutruso.com/wp-content/uploads/2024/05/zalo-2.png" alt="Contact Me on Zalo"/></span>
    </a>
    </div>
  )
}
